import React from 'react';
import { Navigate } from 'react-router-dom';

import useLaunchAccess from '../../../hooks/useLaunchAccess';
import '../../PreLaunch/PreLaunch.css';
import Register from './Register';

export default function RegisterGate() {
  const { loading, canSignUp } = useLaunchAccess();

  if (loading) {
    return (
      <main className="prelaunch-loading" aria-busy="true" aria-label="Checking city availability">
        <span className="prelaunch-loading__heart" aria-hidden="true">♥</span>
        <p>Checking whether signup is open in your city…</p>
      </main>
    );
  }

  if (!canSignUp) {
    return <Navigate to="/#join" replace />;
  }

  return <Register />;
}
